import { combineReducers } from "redux";
import { Auth, LoginHistoryReducer, ChangePasswordReducer, ResetPasswordReducer, GenerateOtpReducer, ValidateOtpReducer } from "./auth/reducers";
import { FieldConfigListReducer } from "./fieldsConfig/reducer";
import {
  FinancierUserListReducer,
  CreateFinancierUserReducer,
  FinancierUserReducer,
  UpdateFinancierUserReducer,
  FetchFinancierUserVesrions,
  ApproveFinancierUserReducer,
  RejectFinancierUserReducer,
  BlockFinancierUserReducer,
  FreezeFinancierUserReducer,
  UnFreezeFinancierUserReducer,
  FetchFinancierUserVesrionDetails,
  DeleteFinancierUserReducer,
  FetchFinancierUserLatestVesrionReducer
} from "./financierUser/reducers";

import {
  UserRoleListReducer,
  CreateUserRoleReducer,
  UserRoleReducer,
  UpdateUserRoleReducer,
  FetchUserRoleVesrions,
  ApproveUserRoleReducer,
  RejectUserRoleReducer,
  ModulePermissionListReducer,
  FetchUserRoleVesrionsDetails,
  FetchUserRoleLatestVesrionsReducer,
  DeleteUserRoleReducer
} from "./userRoles/reducers";
import {
  CurrencyVersionListReducer,
  aproveCurrencyReducer,
  rejectCurrencyReducer,
  blockCurrencyReducer,
  CurrencyListReducer,
  CreateCurrencyReducer,
  CurrencyReducer,
  UpdateCurrencyReducer,
  DeleteCurrencyReducer,
  FreezeCurrencyReducer,
  UnFreezeCurrencyReducer,
  CurrencyVersionDetailsReducer,
  FetchCurrencyLatestVerionReducer
} from "./currency/reducer";
import {
  BaseRateListReducer,
  CreateBaseRateReducer,
  BaseRateReducer,
  NormalBaseRateReducer,
  AdhocBaseRateReducer,
  UpdateBaseRateReducer,
  FetchBaseRateVesrions,
  ApproveBaseRateReducer,
  RejectBaseRateReducer,
  BlockBaseRateReducer,
  FreezeBaseRateReducer,
  UnFreezeBaseRateReducer,
  FetchBaseRateVesrionsDetailsReducer,
  BaseRateReducerLatestVersionReducer,
  DeleteBaseRateReducer
} from "./baseRate/reducer";
import {
  HolidayListReducer,
  HolidayLatestVersionReducer,
  DeleteHolidayReducer,
  CreateHolidayReducer,
  HolidayReducer,
  UpdateHolidayReducer,
  FetchHolidayVesrions,
  ApproveHolidayReducer,
  RejectHolidayReducer,
  BlockHolidayReducer,
  FreezeHolidayReducer,
  UnFreezeHolidayReducer,
  HolidayVersionDetailsReducer
} from "./holiday/reducer";

import {
  HolidayBatchListReducer,
  CreateHolidayBatchReducer,
  HolidayBatchReducer,
  UpdateHolidayBatchReducer,
  FetchHolidayBatchVesrions,
  ApproveHolidayBatchReducer,
  RejectHolidayBatchReducer,
  PublishHolidayBatchReducer,
  HolidayBatchFilterReducer,
  HolidayBatchVersionDetailsReducer,
  DownloadHolidayBatchReducer
} from "./holidayBatch/reducer";
import {
  BranchListReducer,
  CreateBranchReducer,
  BranchReducer,
  FetchBranchVesrions,
  ApproveBranchReducer,
  RejectBranchReducer,
  UpdateBranchReducer,
  BlockBranchReducer,
  FreezeBranchReducer,
  UnFreezeBranchReducer,
  BranchVersionDetailsReducer,
  BranchReducerLatestVerionReducer,
  DeleteBranchReducer
} from "./branch/reducer";
import Layout from "./layout/reducers";

import {
  CountryListReducer,
  CountryReducer,
  CreateCountryReducer,
  UpdateCountryReducer,
  CountryVersionListReducer,
  approveCountryReducer,
  rejectCountryReducer,
  blockCountryReducer,
  FreezeCountryReducer,
  UnFreezeCountryReducer,
  CountryVersionDetailsReducer,
  CountryReducerLatestVersionReducer,
  DeleteCountryReducer
} from "./country/reducers";
import {
  StateListReducer,
  CreateStateReducer,
  StateReducer,
  UpdateStateReducer,
  StateListVersionReducer,
  ApproveStateReducer,
  RejectStateReducer,
  BlockStateReducer,
  FreezeStateReducer,
  UnFreezeStateReducer,
  StateVersionDetailsReducer,
  StateLatestVersionReducer,
  DeleteStateReducer
} from "./state/reducers";
import {
  SystemParameterListReducer,
  SystemParameterReducer,
  UpdateSystemParameterReducer,
  SystemParameterListVersionReducer,
  SystemParameterVersionDetailsReducer,
  SystemParameterLatestVersionReducer,
  ApproveSystemParameterReducer,
  RejectSystemParameterReducer
} from "./systemParameters/reducers";
import {
  CityListReducer,
  CreateCityReducer,
  CityReducer,
  UpdateCityReducer,
  CityListVersionReducer,
  ApproveCityReducer,
  RejectCityReducer,
  BlockCityReducer,
  FreezeCityReducer,
  UnFreezeCityReducer,
  CityVersionDetailsReducer,
  CityReducerLatestVersionReducer,
  DeleteCityReducer
} from "./city/reducers";
import {
  RelationshipManagerListReducer,
  RelationshipMaanagerReducer,
  CreaterelationshipManagerReducer,
  UpdateRelationshipMaanagerReducer,
  RelationshipManagerListVersionReducer,
  AproveRelationshipManagerReducer,
  RejectRelationshipManagerReducer,
  BlockRelationshipManagerReducer,
  FreezeRelationshipManagerReducer,
  UnFreezeRelationshipManagerReducer,
  RelationshipMaanagerVersionDetailsReducer,
  RelationshipMaanagerLatestVersionReducer,
  DeleteRelationshipMaanagerReducer
} from "./relationshipManager/reducer";
import {
  LovListReducer,
  CreateLovListReducer,
  LovByIdReducer,
  UpdateLovReducer,
  LovListTenorReducer,
  LovListVersionReducer,
  AproveLovReducer,
  RejectLovReducer,
  BlockLovReducer,
  FreezeLovReducer,
  UnFreezeLovReducer,
  LovListVersionDetailsReducer,
  LovLatestVersionReducer,
  deleteLOVReducer
} from "./lov/reducer";
import {
  TaskIdByPanNumberReducer,
  TaskStatusByTaskIdReducer,
  TaskResultByTaskIdReducer,
  CustomerIdsReducer,
  CustomerListReducer,
  CustomerReducer,
  CustomerValidateReducer,
  ApproveCustomerReducer,
  RejectCustomerReducer,
  CustomerBlockReducer,
  GstDetailReducer,
  CustomerVersionsReducer,
  CreateCustomerReducer,
  UpdateCustomerReducer,
  DeDuplicateCustomerReducer,
  CustomerFreezeReducer,
  CustomerUnFreezeReducer,
  CustomerVersionsDetailsReducer,
  CustomerLatestVersionsReducer,
  DeleteCustomerReducer,
  FetchCustomerByProgrammeIdReducer
} from "./customer/reducer";

import {
  CustomerCICReportingIdsReducer,
  CustomerCICReportingListReducer,
  CustomerCICReportingReducer,
  CustomerCICReportingVersionReducer,
  CustomerCICReportingLatestVersionReducer,
  CustomerCICReportingVersionsDetailReducer,
  CreateCustomerCICReportingReducer,
  DeleteCustomerCICReportingReducer,
  ApproveCustomerCICReportingReducer,
  RejectCustomerCICReportingReducer,
  UpdateCustomerCICReportingReducer
} from "./customerCICReporting/reducer";
import {
  CreateCustomerContactReducer,
  CustomerContactListReducer,
  CustomerContactBYIdReducer,
  UpdateCustomerContactReducer,
  CreatePartnerContactReducer,
  CreateKeyManagmentContactReducer,
  KeyManagementContactListReducer,
  KeyManagementContactReducer,
  UpdateKeyManagementContactReducer,
  FetchPatnerContactListReducer,
  FetchPartnerContactBYIdReducer,
  UpdatePartnerContactReducer,
  CustomerContactListVersionReducer,
  AproveCustomerContactReducer,
  RejectCustomerContactReducer,
  BlockCustomerContactReducer,
  KeyManagementListVersionReducer,
  AproveKeyManagementReducer,
  RejectKeyManagementReducer,
  BlockKeyManagementReducer,
  PartnerContactListVersionReducer,
  AprovePartnerContactReducer,
  RejectPartnerContactReducer,
  BlockPartnerContactReducer,
  FreezeCustomerContactReducer,
  FreezePartnerContactReducer,
  FreezeKeyManagementReducer,
  UnFreezePartnerContactReducer,
  UnFreezeKeyManagementReducer,
  UnFreezeCustomerContactReducer,
  CustomerContactVersionDetailsReducer,
  DeleteCustomerContactReducer
} from "./customerContact/reducer";
import {
  CustomerAddressListReducer,
  CreateAddressReducer,
  CustomerAddressReducer,
  UpdateCustomerAddressReducer,
  AddressListVersionReducer,
  AproveCustomerAddressReducer,
  RejectCustomerAddressReducer,
  BlockCustomerAddressReducer,
  FreezeCustomerAddressReducer,
  UnFreezeCustomerAddressReducer,
  FetchAddressVersionDetailsReducer,
  FetchAddressLatestVersionReducer,
  DeleteAddressReducer
} from "./customerAddress/reducer";
import {
  CustomerCummunicationsListReducer,
  CustomerCummunicationsCreatereducer,
  CustomerCummunicationsBYIdReducer,
  UpdateCustomerCummunicationsReducer,
  CustomerCummunicationsListVersionReducer,
  AproveCummunicationsReducer,
  RejectCummunicationsReducer,
  BlockCummunicationsReducer,
  FreezeCummunicationsReducer,
  UnFreezeCummunicationsReducer,
  CustomerCummunicationsVersionDetailsReducer,
  CustomerCummunicationsLatestVersionReducer,
  DeleteCustomerCummunicationsReducer
} from "./customerCummications/reducers";
import {
  LimitConfigListReducer,
  CreateLimitConfigReducer,
  deleteLimitConfigReducer,
  FetchLimitConfigReducer,
  UpdateLimitConfigReducer,
  FetchLimitConfigVesrions,
  ApproveLimitConfigReducer,
  RejectLimitConfigReducer,
  BlockLimitConfigReducer,
  FreezeLimitConfigReducer,
  UnFreezeLimitConfigReducer,
  FetchLimitConfigHistroyReducer,
  FetchLimitConfigVersionDetailsReducer,
  FetchLimitConfigLatestVersionReducer,
  FetchAggregateLimitConfigHistroyReducer,
  LimitConfigIdsReducer,
  FetchLimitConfigByCustomerReducer
} from "./limitConfig/reducer";
import { ProductLimitConfigListReducer, CreateProductLimitConfigReducer, UpdateProductLimitConfigReducer, FetchProductLimitConfigReducer } from "./productLimitConfig/reducer";
import { ListApprovedLimitsV2Reducer, LatestVersionLimitsV2Reducer, CreateDraftLimitV2Reducer, PublishLimitV2Reducer, UpdateDraftLimitV2Reducer, ApproveLimitV2Reducer, RejectLimitV2Reducer, DeleteLimitV2Reducer, DeleteLimitV2ByExternalIdReducer, FreezeLimitV2Reducer, UnfreezeLimitV2Reducer } from "./limitConfigV2/reducer";
import {
  ProdcutTypeListReducer,
  ProdcutTypeReducer,
  UpdateProductTypeReducer,
  CreateProdcutTypeReducer,
  ProdcutTypeListVersionReducer,
  RejectProductTypeReducer,
  AproveProductTypeReducer,
  BlockProductTypeReducer,
  FreezeProductTypeReducer,
  UnFreezeProductTypeReducer,
  ProdcutTypeDetailsReducer,
  ProdcutTypeLatestVersionReducer,
  DeleteProductTypeReducer
} from "./productType/reducer";
import {
  CreateCustomerBeneficiaryReducer,
  CustomerBeneficiaryListReducer,
  CustomerBeneficiaryReducer,
  UpdateBeneficiaryReducer,
  CustomerBeneficiaryVersionListReducer,
  AproveBeneficiaryReducer,
  RejectBeneficiaryReducer,
  BlockBeneficiaryReducer,
  FreezeBeneficiaryReducer,
  UnFreezeBeneficiaryReducer,
  CustomerBeneficiaryVersionDetailsReducer,
  CustomerBeneficiaryLatestVersionReducer,
  DeleteCustomerBeneficiaryReducer
} from "./customerBeneficary/reducer";
import {
  ApproveFinancinProgramReducer,
  CreateFinancinProgramReducer,
  FinancingProgramListReducer,
  FinancingProgramValidateReducer,
  FinancingProgramVersionsReducer,
  FinancinProgramReducer,
  RejectFinancinProgramReducer,
  UpdateFinancinProgramReducer,
  FinancinProgramVersionDetailsReducer,
  FinancingProgramLatestVersionsReducer,
  DeleteFinancinProgramReducer,
  GenerateLoanAccountNumberFinancinProgramReducer,
  BlockFinancingProgramReducer,
  FreezeFinancingProgramReducer,
  UnFreezeFinancingProgramReducer,
  FinancingProgramIdsReducer,
  FinancingProgramConfigListReducer,
  FinancingProgramForRepaymentsReducer
} from "./financingPrograms/reducer";
import {
  BuyerSellerIdsReducer,
  BuyerSellersListReducer,
  BuyerSellerCreateRelationAccountNumberReducer,
  BuyerSellerVersionDetailsReducer,
  BuyerSellerLatestVersionReducer,
  DeleteBuyerSellerReducer,
  BuyerSellerReducer,
  BuyerSellerVersionsReducer,
  ApproveBuyerSellerReducer,
  RejectBuyerSellerReducer,
  BuyerSellerBlockReducer,
  UpdateBuyerSellerReducer,
  BuyerSellerValidateReducer,
  CreateBuyerSellerReducer,
  FreezeBuyerSellerReducer,
  UnFreezeBuyerSellerReducer,
  BuyerSellerPartialDisbursementAllowedReducer,
  BuyerSellerConfigValues,
  ProgrammeAndCounterparyBasedBuyerSellerReducer
} from "./buyerSeller/reducer";

import {
  CustomerBeneficiaryProgrammeListReducer,
  CreateCustomerBeneficiaryProgrammeReducer,
  CustomerBeneficiaryProgrammeReducer,
  UpdateBeneficiaryProgrammeReducer,
  CustomerBeneficiaryProgrammeVersionListReducer,
  AproveBeneficiaryProgrammeReducer,
  RejectBeneficiaryProgrammeReducer,
  BlockBeneficiaryProgrammeReducer,
  FreezeBeneficiaryProgrammeReducer,
  UnFreezeBeneficiaryProgrammeReducer
} from "./customerBeneficaryProgrammme/reducer";

import {
  GlAccountReducer,
  CreateGlAccountReducer,
  GlAccountByIdReducer,
  UpdateGlAccountReducer,
  GlAccountListVersionReducer,
  AproveGlAccountReducer,
  RejectGlAccountReducer,
  BlockGlAccountReducer,
  FreezeGlAccountReducer,
  UnFreezeGlAccountReducer,
  GlAccountVersionDetailsReducer,
  DeleteGlAccountReducer,
  GlAccountLatestVersionReducer
} from "./glAccount/reducer";

import {
  ChargeListReducer,
  ChargeReducer,
  CreateChargeReducer,
  UpdateChargeReducer,
  ChargeListVersionReducer,
  ApproveChargeReducer,
  RejectChargeReducer,
  BlockChargeReducer,
  FreezeChargeReducer,
  UnFreezeChargeReducer,
  ChargeVersionDetailsReducer,
  ChargeLatestVersionReducer,
  DeleteChargeReducer,
  CancelChargeReducer
} from "./charge/reducers";
import {
  PayableChargeListReducer,
  PayableChargeReducer,
  CreatePayableChargeReducer,
  UpdatePayableChargeReducer,
  PayableChargeListVersionReducer,
  ApprovePayableChargeReducer,
  RejectPayableChargeReducer,
  BlockPayableChargeReducer,
  FreezePayableChargeReducer,
  UnFreezePayableChargeReducer,
  PayableChargeVersionDetailsReducer,
  PayableChargeLatestVersionReducer,
  DeletePayableChargeReducer,
  CancelPayableChargeReducer
} from "./payableCharge/reducers";
import { InstrumentBatchAuditActionsReducer, InstrumentBatchListReducer, InstrumentBatchReducer, UploadInstrumnetBatchReducer } from "./transaction/instrumentBatch/reducer";
import { InstrumentReducer, InstrumentsReducer } from "./transaction/instrument/reducer";
import {
  DisburseStagingBatchesReducer,
  StagingBatchListReducer,
  StagingBatchReducer,
  StagingBatchReprocessingReducer,
  StagingBatchSkipValidationReducer,
  StagingBatchVersionReducer,
  AproveStagingBatchesReducer,
  RejectStagingBatchesReducer,
  StagingBatchChildListReducer,
  MakerRemarkStagingBatchSkipValidationReducer,
  MakerRemarkDisburseStagingBatchesReducer,
  UpdateStagingBatchLimitTypeReducer,
  StagingBatchAuditActionsReducer,
  StagingBatchReRunValidationsReducer,
  PickupStagingBatchReducer,
  ReleaseStagingBatchReducer
} from "./transaction/stagingBatch/reducer";
import {
  SkipableValidationsStagingInstrumentsListReducer,
  StagingInstrumentReducer,
  StagingInstrumentsReprocessingReducer,
  ValidationErrorByStagingInstrumentIdReducer,
  RemoveStagingInstrumentsListReducer,
  StagingInstrumentsRemoveVersionListReducer,
  RemoveStagingInstrumentsReducer,
  StagingInstrumentDocumentsReducer,
  DownloadStagingInstrumentDocumentReducer
} from "./transaction/stagingInstrument/reducer";
import { StagingInstrumentsListReducer, StagingInstrumentsSkipValidationReducer } from "./transaction/stagingInstrument/reducer";
import { PaymentInstrumentReducer, PaymentInstrumnetListReducer } from "./transaction/paymentInstrument/reducer";
import {
  PaymentBatchListReducer,
  PaymentBatchReducer,
  MarkeRemarkReProcessingPaymentBatchReducer,
  ApprovalPaymentBatchReducer,
  RejectPaymentBatchReducer,
  PaymentBatchVersionListReducer,
  PaymentBatchAuditActionsReducer
} from "./transaction/payment/reducer";

import {
  EodJobReducer,
  EodJobLoggedInUsers,
  ForceLogoutUsersReducer,
  GetEodJobStatusReducer,
  InitialUpdatebusinessDetailReducer,
  GetbusinessDetailReducer,
  UpdatebusinessDetailReducer
} from "./eodBod/reducers";
import { DisbursementsReducer } from "./transaction/disbursement/reducer";

import { IntrumenetInterestAccrualsReducer, IntrumenetInterestAccrualReducer } from "./transaction/interestAccrual/reducer";
import { InstrumentDailyBalanceReducer, InstrumentDailyBalancesReducer } from "./transaction/dailyBalances/reducer";
import { InstrumentDailyBalancesHistoryReducer, InstrumentDailyBalanceHistoryReducer } from "./transaction/instrumentDailyBalancesHistory/reducer";

import {
  RepaymentListReducer,
  UploadRepaymentReducer,
  RepaymentReducer,
  RepaymentListVersionReducer,
  ApproveRepaymentReducer,
  RejectRepaymentReducer,
  UploadRepaymentSettlementReducer,
  RepaymentFiltersReducer,
  RepaymentAdjustmentEntriesReducer,
  RepaymentAdjustmentEntrieReducer,
  RepaymentStagedAdjustmentEntrieReducer,
  CreateRepaymentRequestSettleReducer,
  RepaymentStagedAdjustmentEntriesReducer,
  CreateRepaymentRequestSettleManuallyReducer,
  ReviewFIFORepaymentReducer,
  RepaymentAuditActionsReducer
} from "./Repayment/repaymentRequest/reducers";

import {
  DisbursementAuthListReducer,
  CreateDisbursementAuthReducer,
  DisbursementAuthReducer,
  UpdateDisbursementAuthReducer,
  PublishDisbursementAuthReducer,
  FetchDisbursementAuthVesrions,
  ApproveDisbursementAuthReducer,
  RejectDisbursementAuthReducer,
  BlockDisbursementAuthReducer,
  FreezeDisbursementAuthReducer,
  UnFreezeDisbursementAuthReducer,
  DisbursementAuthAuditActionsReducer,
  DownloadDisbursementAuthReducer,
  DownloadPendingPaymentBatchReducer
} from "./DisbursementAuth/reducer";
import { CreateProgrammeSummaryReducer } from "./report/programmeSummary/reducer";

import { CreateDisbursementAdviceReducer } from "./report/disbursementAdvice/reducer";
import { CreateLimitReportReducer } from "./report/limitReport/reducer";
import { CreateClientSummaryReducer } from "./report/clientSummary/reducer";

import { CreateInterestComputationReducer } from "./report/interestComputation/reducer";
import { CreateRepaymentAdviceReducer } from "./report/repaymentAdvice/reducer";
import { ExcessMoneyListReducer, ExcessMoneyReducer } from "./Repayment/excessMoney/reducer";
import { ExcessRefundListReducer, ExcessRefundReducer } from "./Repayment/excessRefund/reducer";
import { ExcessMoneySettlementListReducer, ExcessMoneySettlementReducer } from "./Repayment/excessMoneySettlement/reducer";
import { ApproveExcessMoneyRefundReducer, CreateExcessMoneyRefundReducer, RejectExcessMoneyRefundReducer } from "./Repayment/excessMoneyRefund/reducer";
import { InstrumentBatchUploadListReducer, InstrumentBatchUploadReducer, InstrumentsListByBatchIdReducer } from "./transaction/instrumentBatchUpload/reducer";
import { CreateNpaReportReducer } from "./report/npaReport/reducer";
import { CreateLifeCycleReducer } from "./report/lifeCycleReport/reducer";
import { ApproveChargeSettlementReducer, ChargeSettlementAuditActionsReducer, ChargeSettlementDetailReducer, ChargeSettlementListReducer, CreateChargeSettlementReducer, RejectChargeSettlementReducer } from "./Repayment/chargeSettlement/reducer";
import { CreateFundingDetailsReducer } from "./report/fundingDetails/reducer";
import {
  ApproveRepaymentBulkIntrumentReducer,
  CreateRepaymentBulkIntrumentReducer,
  RejectRepaymentBulkIntrumentReducer,
  RepaymentBulkIntrumentAuditReducer,
  RepaymentBulkIntrumentDetailReducer,
  RepaymentBulkIntrumentSettledEntriesDetailReducer,
  RepaymentBulkIntrumentSettledEntriesReducer,
  RepaymentBulkIntrumentsFiltersListReducer,
  RepaymentBulkIntrumentsListReducer,
  RepaymentBulkIntrumentVersionReducer,
  ReviewRepaymentBulkIntrumentReducer
} from "./Repayment/repayment-intrument-bulk-request/reducer";
import { DownloadReportReducer, ListReportReducer } from "./report/commonReports/reducer";
import { ApproveBulkCustomersFileReducer, BulkCustomersDetailReducer, BulkCustomersPublishReducer, BulkCustomersVersionRecordReducer, DeDuplicateBulkCustomersFileCheckReducer, DeleteBulkCustomersFileReducer, DownloaBulkCustomersReducer, ListBulkCustomersReducer, ListBulkFileSpecificCustomersReducer, RejectBulkCustomersFileReducer, UploadBulkCustomersReducer } from "./bulkCustomer/reducer";
import {
  ApproveBulkCustomerCicReportingFileReducer,
  BulkCustomerCicReportingDetailReducer,
  BulkCustomerCicReportingPublishReducer,
  BulkCustomerCicReportingVersionRecordReducer,
  DeleteBulkCustomerCicReportingFileReducer,
  DownloadBulkCustomerCicReportingReducer,
  ListBulkCustomerCicReportingReducer,
  ListBulkFileSpecificCustomerCicReportingReducer,
  RejectBulkCustomerCicReportingFileReducer,
  UploadBulkCustomerCicReportingReducer
} from "./bulkCustomerCicReporting/reducer";
import { ApproveBulkBuyerSellersFileReducer, BulkBuyerSellersFileDetailReducer, BulkBuyerSellersFileVersionReducer, DeleteBulkBuyerSellersFileReducer, DownloadBulkBuyerSellersFileReducer, ListBulkBuyerSellersFileReducer, ListBulkFileSpecificBuyerSellersReducer, PublishBulkBuyerSellersFileReducer, RejectBulkBuyerSellersFileReducer, UploadBulkBuyerSellersFileReducer } from "./bulkBuyerSeller/reducer";
import { ApproveBulkProgrammesFileReducer, BulkProgrammesFileDetailReducer, BulkProgrammesFileVersionReducer, DeleteBulkProgrammesFileReducer, DownloadBulkProgrammesFileReducer, ListBulkFileSpecificProgrammesReducer, ListBulkProgrammesFileReducer, PublishBulkProgrammesFileReducer, RejectBulkProgrammesFileReducer, UploadBulkProgrammesFileReducer } from "./bulkFinancingProgramme/reducer";
import { ApproveBulkLimitConfigFileReducer, BulkLimitConfigFileDetailReducer, BulkLimitConfigFileVersionReducer, DeleteBulkLimitConfigFileReducer, DownloadBulkLimitConfigFileReducer, ListBulkFileSpecificLimitConfigReducer, ListBulkLimitConfigFileReducer, PublishBulkLimitConfigFileReducer, RejectBulkLimitConfigFileReducer, UploadBulkLimitConfigFileReducer } from "./bulkLimitConfig/reducer";
import { UploadBulkBeneficiaryFileReducer, ListBulkBeneficiaryFileReducer, DownloadBulkBeneficiaryFileReducer, BulkBeneficiaryFileDetailReducer, BulkBeneficiaryFileVersionReducer, PublishBulkBeneficiaryFileReducer, ApproveBulkBeneficiaryFileReducer, RejectBulkBeneficiaryFileReducer, ListBulkFileSpecificBeneficiaryReducer, DeleteBulkBeneficiaryFileReducer } from "./bulkBeneficiary/reducer";
import { CreateOverdueReportReducer } from "./report/overdueReport/reducer";
import { CreateIntegLogReportReducer } from "./report/integLogReport.ts/reducer";
import { CoLenderFinancierListReducer, CoLenderFinancierReducer, CoLenderFinancierVersionsReducer, CreateCoLenderFinancierReducer, DeleteCoLenderFinancierReducer, UpdateCoLenderFinancierReducer , BlockCoLenderFinancierReducer, ApproveCoLenderFinancierReducer, RejectCoLenderFinancierReducer, FreezeCoLenderFinancierReducer, UnfreezeCoLenderFinancierReducer, CoLenderFinancierVersionDetailsReducer, CoLenderFinancierLatestVersionReducer } from "./coLenderFinancier/reducer";
import { CreateStatementOfAccountsReducer } from "./report/statementOfAccounts/reducer";
import { CreateUnrealisedIncomeReportReducer } from "./report/unrealisedIncome/reducer";
import { CreateOneViewReportReducer } from "./report/oneViewReport/reducer";
import { CreateChargeSummaryReportReducer } from "./report/chargeSummary/reducer";
import { CreateAmortizationReportReducer } from "./report/amortizationReport/reducer";
import { CreateBuyerSellerDumpReportReducer } from "./report/buyerSellerDump/reducer";
import { CreateProgrammesDumpReportReducer } from "./report/programmesDump/reducer";
import { CreateCustomerDumpReportReducer } from "./report/customerDump/reducer";
import { CreateCrilicReportReducer } from "./report/crilicReport/reducer";

export default combineReducers({
  Auth,
  LoginHistoryReducer,
  FieldConfigListReducer,
  ChangePasswordReducer,
  ResetPasswordReducer,
  GenerateOtpReducer,
  ValidateOtpReducer,
  Layout,

  FinancierUserListReducer,
  FinancierUserReducer,
  CreateFinancierUserReducer,
  UpdateFinancierUserReducer,
  FetchFinancierUserVesrions,
  ApproveFinancierUserReducer,
  RejectFinancierUserReducer,
  BlockFinancierUserReducer,
  FreezeFinancierUserReducer,
  UnFreezeFinancierUserReducer,
  FetchFinancierUserVesrionDetails,
  DeleteFinancierUserReducer,
  FetchFinancierUserLatestVesrionReducer,
  ModulePermissionListReducer,
  FetchUserRoleVesrionsDetails,
  FetchUserRoleLatestVesrionsReducer,
  FetchCurrencyLatestVerionReducer,
  DeleteUserRoleReducer,

  UserRoleListReducer,
  CreateUserRoleReducer,
  UserRoleReducer,
  UpdateUserRoleReducer,
  FetchUserRoleVesrions,
  ApproveUserRoleReducer,
  RejectUserRoleReducer,

  CurrencyListReducer,
  CreateCurrencyReducer,
  CurrencyReducer,
  UpdateCurrencyReducer,
  DeleteCurrencyReducer,
  CurrencyVersionListReducer,
  aproveCurrencyReducer,
  rejectCurrencyReducer,
  blockCurrencyReducer,
  FreezeCurrencyReducer,
  UnFreezeCurrencyReducer,
  CurrencyVersionDetailsReducer,

  BaseRateListReducer,
  BaseRateReducer,
  NormalBaseRateReducer,
  AdhocBaseRateReducer,
  CreateBaseRateReducer,
  UpdateBaseRateReducer,
  FetchBaseRateVesrions,
  ApproveBaseRateReducer,
  RejectBaseRateReducer,
  BlockBaseRateReducer,
  FreezeBaseRateReducer,
  UnFreezeBaseRateReducer,
  FetchBaseRateVesrionsDetailsReducer,
  BaseRateReducerLatestVersionReducer,
  DeleteBaseRateReducer,
  HolidayListReducer,
  HolidayLatestVersionReducer,
  DeleteHolidayReducer,
  CreateHolidayReducer,
  HolidayReducer,
  UpdateHolidayReducer,
  FetchHolidayVesrions,
  ApproveHolidayReducer,
  RejectHolidayReducer,
  BlockHolidayReducer,
  FreezeHolidayReducer,
  UnFreezeHolidayReducer,
  HolidayVersionDetailsReducer,

  HolidayBatchListReducer,
  CreateHolidayBatchReducer,
  HolidayBatchReducer,
  UpdateHolidayBatchReducer,
  FetchHolidayBatchVesrions,
  ApproveHolidayBatchReducer,
  RejectHolidayBatchReducer,
  PublishHolidayBatchReducer,
  HolidayBatchFilterReducer,
  HolidayBatchVersionDetailsReducer,
  DownloadHolidayBatchReducer,

  BranchListReducer,
  BranchVersionDetailsReducer,
  BranchReducerLatestVerionReducer,
  DeleteBranchReducer,

  CreateBranchReducer,
  BranchReducer,
  FetchBranchVesrions,
  ApproveBranchReducer,
  RejectBranchReducer,
  UpdateBranchReducer,
  BlockBranchReducer,
  FreezeBranchReducer,
  UnFreezeBranchReducer,

  CountryListReducer,
  CreateCountryReducer,
  CountryReducer,
  UpdateCountryReducer,
  CountryVersionListReducer,
  approveCountryReducer,
  rejectCountryReducer,
  blockCountryReducer,
  FreezeCountryReducer,
  UnFreezeCountryReducer,
  CountryVersionDetailsReducer,
  CountryReducerLatestVersionReducer,
  DeleteCountryReducer,

  StateListReducer,
  CreateStateReducer,
  StateReducer,
  UpdateStateReducer,
  StateListVersionReducer,
  ApproveStateReducer,
  RejectStateReducer,
  BlockStateReducer,
  FreezeStateReducer,
  UnFreezeStateReducer,
  StateVersionDetailsReducer,
  StateLatestVersionReducer,
  DeleteStateReducer,

  RelationshipManagerListReducer,
  CreaterelationshipManagerReducer,
  RelationshipMaanagerReducer,
  UpdateRelationshipMaanagerReducer,
  RelationshipManagerListVersionReducer,
  AproveRelationshipManagerReducer,
  RejectRelationshipManagerReducer,
  BlockRelationshipManagerReducer,
  FreezeRelationshipManagerReducer,
  UnFreezeRelationshipManagerReducer,
  RelationshipMaanagerVersionDetailsReducer,
  RelationshipMaanagerLatestVersionReducer,
  DeleteRelationshipMaanagerReducer,

  LovListReducer,
  CreateLovListReducer,
  LovByIdReducer,
  UpdateLovReducer,
  LovListTenorReducer,
  LovListVersionReducer,
  AproveLovReducer,
  RejectLovReducer,
  BlockLovReducer,
  FreezeLovReducer,
  UnFreezeLovReducer,
  LovListVersionDetailsReducer,
  LovLatestVersionReducer,
  deleteLOVReducer,

  GlAccountReducer,
  CreateGlAccountReducer,
  GlAccountByIdReducer,
  UpdateGlAccountReducer,
  GlAccountListVersionReducer,
  AproveGlAccountReducer,
  RejectGlAccountReducer,
  BlockGlAccountReducer,
  FreezeGlAccountReducer,
  UnFreezeGlAccountReducer,
  GlAccountVersionDetailsReducer,
  DeleteGlAccountReducer,

  CityListReducer,
  CreateCityReducer,
  CityReducer,
  UpdateCityReducer,
  CityListVersionReducer,
  ApproveCityReducer,
  RejectCityReducer,
  BlockCityReducer,
  FreezeCityReducer,
  UnFreezeCityReducer,
  CityVersionDetailsReducer,
  CityReducerLatestVersionReducer,
  DeleteCityReducer,

  CoLenderFinancierListReducer,
  CreateCoLenderFinancierReducer,
  UpdateCoLenderFinancierReducer,
  CoLenderFinancierReducer,
  DeleteCoLenderFinancierReducer,
  CoLenderFinancierVersionsReducer,
  CoLenderFinancierVersionDetailsReducer,
  CoLenderFinancierLatestVersionReducer,
  BlockCoLenderFinancierReducer,
  ApproveCoLenderFinancierReducer,
  RejectCoLenderFinancierReducer,
  FreezeCoLenderFinancierReducer,
  UnfreezeCoLenderFinancierReducer,

  CustomerIdsReducer,
  CustomerListReducer,
  CustomerReducer,
  CustomerVersionsReducer,
  ApproveCustomerReducer,
  RejectCustomerReducer,
  TaskIdByPanNumberReducer,
  TaskStatusByTaskIdReducer,
  TaskResultByTaskIdReducer,
  GstDetailReducer,
  CustomerValidateReducer,
  CreateCustomerReducer,
  UpdateCustomerReducer,
  UploadBulkCustomersReducer,
  ListBulkCustomersReducer,
  BulkCustomersDetailReducer,
  BulkCustomersVersionRecordReducer,
  BulkCustomersPublishReducer,
  DownloaBulkCustomersReducer,
  ListBulkFileSpecificCustomersReducer,
  ApproveBulkCustomersFileReducer,
  RejectBulkCustomersFileReducer,
  DeDuplicateBulkCustomersFileCheckReducer,
  DeleteBulkCustomersFileReducer,

  UploadBulkCustomerCicReportingReducer,
  ListBulkCustomerCicReportingReducer,
  BulkCustomerCicReportingDetailReducer,
  BulkCustomerCicReportingVersionRecordReducer,
  BulkCustomerCicReportingPublishReducer,
  DownloadBulkCustomerCicReportingReducer,
  ListBulkFileSpecificCustomerCicReportingReducer,
  ApproveBulkCustomerCicReportingFileReducer,
  RejectBulkCustomerCicReportingFileReducer,
  DeleteBulkCustomerCicReportingFileReducer,

  CustomerCICReportingIdsReducer,
  CustomerCICReportingListReducer,
  CustomerCICReportingReducer,
  CustomerCICReportingVersionReducer,
  CustomerCICReportingLatestVersionReducer,
  CustomerCICReportingVersionsDetailReducer,
  CreateCustomerCICReportingReducer,
  DeleteCustomerCICReportingReducer,
  ApproveCustomerCICReportingReducer,
  RejectCustomerCICReportingReducer,
  UpdateCustomerCICReportingReducer,

  CreateCustomerContactReducer,
  FetchCustomerByProgrammeIdReducer,
  CustomerContactListReducer,
  DeDuplicateCustomerReducer,
  CustomerFreezeReducer,
  CustomerUnFreezeReducer,
  CustomerVersionsDetailsReducer,
  CustomerLatestVersionsReducer,
  DeleteCustomerReducer,
  CustomerContactBYIdReducer,
  UpdateCustomerContactReducer,
  KeyManagementContactReducer,
  UpdateKeyManagementContactReducer,
  FetchPatnerContactListReducer,
  FetchPartnerContactBYIdReducer,
  UpdatePartnerContactReducer,
  CustomerBlockReducer,
  CustomerContactListVersionReducer,
  AproveCustomerContactReducer,
  RejectCustomerContactReducer,
  BlockCustomerContactReducer,
  KeyManagementListVersionReducer,
  AproveKeyManagementReducer,
  RejectKeyManagementReducer,
  BlockKeyManagementReducer,
  PartnerContactListVersionReducer,
  AprovePartnerContactReducer,
  RejectPartnerContactReducer,
  BlockPartnerContactReducer,
  CreatePartnerContactReducer,
  CreateKeyManagmentContactReducer,
  KeyManagementContactListReducer,

  FreezeCustomerContactReducer,
  FreezePartnerContactReducer,
  FreezeKeyManagementReducer,

  UnFreezePartnerContactReducer,
  UnFreezeKeyManagementReducer,
  UnFreezeCustomerContactReducer,
  CustomerContactVersionDetailsReducer,
  DeleteCustomerContactReducer,

  CustomerAddressListReducer,
  CreateAddressReducer,
  CustomerAddressReducer,
  UpdateCustomerAddressReducer,
  AddressListVersionReducer,
  AproveCustomerAddressReducer,
  RejectCustomerAddressReducer,
  BlockCustomerAddressReducer,
  FreezeCustomerAddressReducer,
  UnFreezeCustomerAddressReducer,
  FetchAddressVersionDetailsReducer,
  FetchAddressLatestVersionReducer,
  DeleteAddressReducer,

  CustomerCummunicationsListReducer,
  CustomerCummunicationsCreatereducer,
  CustomerCummunicationsBYIdReducer,
  UpdateCustomerCummunicationsReducer,
  DeleteCustomerCummunicationsReducer,
  CustomerCummunicationsListVersionReducer,
  AproveCummunicationsReducer,
  RejectCummunicationsReducer,
  BlockCummunicationsReducer,
  FreezeCummunicationsReducer,
  UnFreezeCummunicationsReducer,
  CustomerCummunicationsVersionDetailsReducer,
  CustomerCummunicationsLatestVersionReducer,

  LimitConfigListReducer,
  FetchLimitConfigByCustomerReducer,
  CreateLimitConfigReducer,
  deleteLimitConfigReducer,
  UpdateLimitConfigReducer,
  FetchLimitConfigVesrions,
  ApproveLimitConfigReducer,
  RejectLimitConfigReducer,
  BlockLimitConfigReducer,
  FreezeLimitConfigReducer,
  UnFreezeLimitConfigReducer,
  FetchLimitConfigHistroyReducer,
  FetchAggregateLimitConfigHistroyReducer,
  FetchLimitConfigVersionDetailsReducer,
  FetchLimitConfigLatestVersionReducer,
  ProductLimitConfigListReducer,
  CreateProductLimitConfigReducer,
  FetchProductLimitConfigReducer,
  UpdateProductLimitConfigReducer,
  ListApprovedLimitsV2Reducer,
  LatestVersionLimitsV2Reducer,
  CreateDraftLimitV2Reducer,
  PublishLimitV2Reducer,
  UpdateDraftLimitV2Reducer,
  ApproveLimitV2Reducer,
  RejectLimitV2Reducer,
  DeleteLimitV2Reducer,
  DeleteLimitV2ByExternalIdReducer,
  FreezeLimitV2Reducer,
  UnfreezeLimitV2Reducer,

  //bulk limit config
  UploadBulkLimitConfigFileReducer,
  ListBulkLimitConfigFileReducer,
  DownloadBulkLimitConfigFileReducer,
  BulkLimitConfigFileDetailReducer,
  BulkLimitConfigFileVersionReducer,
  PublishBulkLimitConfigFileReducer,
  ApproveBulkLimitConfigFileReducer,
  RejectBulkLimitConfigFileReducer,
  ListBulkFileSpecificLimitConfigReducer,
  DeleteBulkLimitConfigFileReducer,

  ProdcutTypeListReducer,
  ProdcutTypeReducer,
  UpdateProductTypeReducer,
  CreateProdcutTypeReducer,
  ProdcutTypeListVersionReducer,
  RejectProductTypeReducer,
  AproveProductTypeReducer,
  BlockProductTypeReducer,
  FreezeProductTypeReducer,
  UnFreezeProductTypeReducer,
  ProdcutTypeDetailsReducer,
  ProdcutTypeLatestVersionReducer,
  DeleteProductTypeReducer,
  GlAccountLatestVersionReducer,
  ChargeListReducer,
  ChargeReducer,
  CreateChargeReducer,
  UpdateChargeReducer,
  ChargeListVersionReducer,
  ApproveChargeReducer,
  RejectChargeReducer,
  BlockChargeReducer,
  FreezeChargeReducer,
  UnFreezeChargeReducer,
  ChargeVersionDetailsReducer,
  ChargeLatestVersionReducer,
  DeleteChargeReducer,
  CancelChargeReducer,

  PayableChargeListReducer,
  PayableChargeReducer,
  CreatePayableChargeReducer,
  UpdatePayableChargeReducer,
  PayableChargeListVersionReducer,
  ApprovePayableChargeReducer,
  RejectPayableChargeReducer,
  BlockPayableChargeReducer,
  FreezePayableChargeReducer,
  UnFreezePayableChargeReducer,
  PayableChargeVersionDetailsReducer,
  PayableChargeLatestVersionReducer,
  DeletePayableChargeReducer,
  CancelPayableChargeReducer,

  CustomerBeneficiaryListReducer,
  CreateCustomerBeneficiaryReducer,
  CustomerBeneficiaryVersionListReducer,
  AproveBeneficiaryReducer,
  RejectBeneficiaryReducer,
  BlockBeneficiaryReducer,
  FreezeBeneficiaryReducer,
  UnFreezeBeneficiaryReducer,
  CustomerBeneficiaryVersionDetailsReducer,
  CustomerBeneficiaryLatestVersionReducer,
  DeleteCustomerBeneficiaryReducer,

  FinancingProgramListReducer,
  FinancinProgramReducer,
  FinancingProgramVersionsReducer,
  ApproveFinancinProgramReducer,
  RejectFinancinProgramReducer,
  FinancingProgramValidateReducer,
  CreateFinancinProgramReducer,
  UpdateFinancinProgramReducer,
  FinancinProgramVersionDetailsReducer,
  FinancingProgramLatestVersionsReducer,
  DeleteFinancinProgramReducer,
  GenerateLoanAccountNumberFinancinProgramReducer,
  BlockFinancingProgramReducer,
  FreezeFinancingProgramReducer,
  UnFreezeFinancingProgramReducer,
  FinancingProgramIdsReducer,
  FinancingProgramConfigListReducer,
  FinancingProgramForRepaymentsReducer,

  CustomerBeneficiaryReducer,
  FetchLimitConfigReducer,
  LimitConfigIdsReducer,
  UpdateBeneficiaryReducer,

  //bulk financing programme
  UploadBulkProgrammesFileReducer,
  ListBulkProgrammesFileReducer,
  DownloadBulkProgrammesFileReducer,
  BulkProgrammesFileDetailReducer,
  BulkProgrammesFileVersionReducer,
  PublishBulkProgrammesFileReducer,
  ApproveBulkProgrammesFileReducer,
  RejectBulkProgrammesFileReducer,
  ListBulkFileSpecificProgrammesReducer,
  DeleteBulkProgrammesFileReducer,

  //buyerSeller
  BuyerSellerIdsReducer,
  BuyerSellersListReducer,
  BuyerSellerCreateRelationAccountNumberReducer,
  BuyerSellerVersionDetailsReducer,
  BuyerSellerLatestVersionReducer,
  DeleteBuyerSellerReducer,
  BuyerSellerReducer,
  BuyerSellerVersionsReducer,
  ApproveBuyerSellerReducer,
  RejectBuyerSellerReducer,
  BuyerSellerBlockReducer,
  UpdateBuyerSellerReducer,
  BuyerSellerValidateReducer,
  CreateBuyerSellerReducer,
  FreezeBuyerSellerReducer,
  UnFreezeBuyerSellerReducer,
  BuyerSellerPartialDisbursementAllowedReducer,
  BuyerSellerConfigValues,
  ProgrammeAndCounterparyBasedBuyerSellerReducer,

  CustomerBeneficiaryProgrammeListReducer,
  CreateCustomerBeneficiaryProgrammeReducer,
  CustomerBeneficiaryProgrammeReducer,
  UpdateBeneficiaryProgrammeReducer,
  CustomerBeneficiaryProgrammeVersionListReducer,
  AproveBeneficiaryProgrammeReducer,
  RejectBeneficiaryProgrammeReducer,
  BlockBeneficiaryProgrammeReducer,

  //bulk buyerSeller
  UploadBulkBuyerSellersFileReducer,
  ListBulkBuyerSellersFileReducer,
  DownloadBulkBuyerSellersFileReducer,
  BulkBuyerSellersFileDetailReducer,
  BulkBuyerSellersFileVersionReducer,
  PublishBulkBuyerSellersFileReducer,
  ApproveBulkBuyerSellersFileReducer,
  RejectBulkBuyerSellersFileReducer,
  ListBulkFileSpecificBuyerSellersReducer,

  //bulk beneficiary
  UploadBulkBeneficiaryFileReducer,
  ListBulkBeneficiaryFileReducer,
  DownloadBulkBeneficiaryFileReducer,
  BulkBeneficiaryFileDetailReducer,
  BulkBeneficiaryFileVersionReducer,
  PublishBulkBeneficiaryFileReducer,
  ApproveBulkBeneficiaryFileReducer,
  RejectBulkBeneficiaryFileReducer,
  ListBulkFileSpecificBeneficiaryReducer,
  DeleteBulkBeneficiaryFileReducer,
  DeleteBulkBuyerSellersFileReducer,

  InstrumentBatchListReducer,
  UploadInstrumnetBatchReducer,
  InstrumentBatchReducer,
  InstrumentBatchAuditActionsReducer,
  InstrumentBatchUploadListReducer,
  InstrumentBatchUploadReducer,
  InstrumentsListByBatchIdReducer,
  InstrumentReducer,
  InstrumentsReducer,
  FreezeBeneficiaryProgrammeReducer,
  UnFreezeBeneficiaryProgrammeReducer,
  StagingBatchListReducer,
  StagingBatchReducer,
  StagingInstrumentsListReducer,
  StagingInstrumentReducer,
  StagingInstrumentsReprocessingReducer,
  StagingInstrumentsSkipValidationReducer,
  StagingBatchReRunValidationsReducer,
  StagingInstrumentDocumentsReducer,
  DownloadStagingInstrumentDocumentReducer,
  PaymentBatchListReducer,
  MarkeRemarkReProcessingPaymentBatchReducer,
  PaymentBatchAuditActionsReducer,
  ApprovalPaymentBatchReducer,
  RejectPaymentBatchReducer,
  PaymentBatchVersionListReducer,
  StagingBatchSkipValidationReducer,
  StagingBatchReprocessingReducer,
  PaymentInstrumnetListReducer,
  PaymentInstrumentReducer,
  PaymentBatchReducer,
  DisburseStagingBatchesReducer,
  StagingBatchVersionReducer,
  AproveStagingBatchesReducer,
  RejectStagingBatchesReducer,
  StagingBatchChildListReducer,
  MakerRemarkStagingBatchSkipValidationReducer,
  MakerRemarkDisburseStagingBatchesReducer,
  SkipableValidationsStagingInstrumentsListReducer,
  ValidationErrorByStagingInstrumentIdReducer,
  RemoveStagingInstrumentsListReducer,
  StagingInstrumentsRemoveVersionListReducer,
  UpdateStagingBatchLimitTypeReducer,
  RemoveStagingInstrumentsReducer,
  StagingBatchAuditActionsReducer,
  PickupStagingBatchReducer,
  ReleaseStagingBatchReducer,

  EodJobReducer,
  EodJobLoggedInUsers,
  GetbusinessDetailReducer,
  UpdatebusinessDetailReducer,
  GetEodJobStatusReducer,
  InitialUpdatebusinessDetailReducer,
  DisbursementsReducer,
  ForceLogoutUsersReducer,

  IntrumenetInterestAccrualsReducer,
  IntrumenetInterestAccrualReducer,
  InstrumentDailyBalanceReducer,
  InstrumentDailyBalancesReducer,

  //repayment
  RepaymentListReducer,
  UploadRepaymentReducer,
  RepaymentReducer,
  RepaymentListVersionReducer,
  ApproveRepaymentReducer,
  RejectRepaymentReducer,
  UploadRepaymentSettlementReducer,
  RepaymentFiltersReducer,
  RepaymentAdjustmentEntriesReducer,
  RepaymentAdjustmentEntrieReducer,
  RepaymentStagedAdjustmentEntrieReducer,
  CreateRepaymentRequestSettleReducer,
  CreateRepaymentRequestSettleManuallyReducer,
  ReviewFIFORepaymentReducer,
  RepaymentStagedAdjustmentEntriesReducer,
  InstrumentDailyBalancesHistoryReducer,
  InstrumentDailyBalanceHistoryReducer,
  ExcessMoneyListReducer,
  ExcessMoneyReducer,
  ExcessRefundListReducer,
  ExcessRefundReducer,
  ExcessMoneySettlementReducer,
  ExcessMoneySettlementListReducer,
  CreateExcessMoneyRefundReducer,
  ApproveExcessMoneyRefundReducer,
  RejectExcessMoneyRefundReducer,
  ChargeSettlementDetailReducer,
  ChargeSettlementListReducer,
  ChargeSettlementAuditActionsReducer,
  CreateChargeSettlementReducer,
  ApproveChargeSettlementReducer,
  RejectChargeSettlementReducer,
  CreateRepaymentBulkIntrumentReducer,
  RepaymentBulkIntrumentsListReducer,
  RepaymentBulkIntrumentDetailReducer,
  RepaymentBulkIntrumentVersionReducer,
  RepaymentBulkIntrumentsFiltersListReducer,
  ApproveRepaymentBulkIntrumentReducer,
  RejectRepaymentBulkIntrumentReducer,
  RepaymentBulkIntrumentSettledEntriesReducer,
  RepaymentBulkIntrumentSettledEntriesDetailReducer,
  ReviewRepaymentBulkIntrumentReducer,
  RepaymentAuditActionsReducer,
  RepaymentBulkIntrumentAuditReducer,

  DisbursementAuthListReducer,
  CreateDisbursementAuthReducer,
  DisbursementAuthReducer,
  UpdateDisbursementAuthReducer,
  PublishDisbursementAuthReducer,
  FetchDisbursementAuthVesrions,
  ApproveDisbursementAuthReducer,
  RejectDisbursementAuthReducer,
  BlockDisbursementAuthReducer,
  FreezeDisbursementAuthReducer,
  UnFreezeDisbursementAuthReducer,
  CreateDisbursementAdviceReducer,
  ListReportReducer,
  DownloadReportReducer,
  CreateLimitReportReducer,
  CreateClientSummaryReducer,
  CreateStatementOfAccountsReducer,
  DisbursementAuthAuditActionsReducer,
  DownloadDisbursementAuthReducer,
  DownloadPendingPaymentBatchReducer,
  CreateInterestComputationReducer,
  CreateRepaymentAdviceReducer,
  CreateProgrammeSummaryReducer,
  CreateNpaReportReducer,
  CreateOverdueReportReducer,
  CreateLifeCycleReducer,
  CreateFundingDetailsReducer,
  CreateIntegLogReportReducer,
  CreateUnrealisedIncomeReportReducer,
  CreateOneViewReportReducer,
  CreateChargeSummaryReportReducer,
  CreateAmortizationReportReducer,
  CreateBuyerSellerDumpReportReducer,
  CreateProgrammesDumpReportReducer,
  CreateCustomerDumpReportReducer,
  CreateCrilicReportReducer,

  SystemParameterListReducer,
  SystemParameterReducer,
  UpdateSystemParameterReducer,
  SystemParameterListVersionReducer,
  SystemParameterVersionDetailsReducer,
  SystemParameterLatestVersionReducer,
  ApproveSystemParameterReducer,
  RejectSystemParameterReducer
});
